import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
/**
 * Baseline button used by both UI personalities (§5) — the Accountant panel uses `md`
 * for form/table-adjacent actions; the POS till should prefer `TouchButton`
 * (`pos/TouchButton.tsx`), which wraps this with §5's larger tactile sizing baked in by
 * default rather than left to the caller to remember.
 */
export const Button = forwardRef(function Button({ variant = "primary", size = "md", className, style, ...rest }, ref) {
    return (_jsx("button", { ref: ref, className: ["sl-button", `sl-button--${variant}`, `sl-button--${size}`, className]
            .filter(Boolean)
            .join(" "), style: style, ...rest }));
});
//# sourceMappingURL=Button.js.map